
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

export default {
  name: "HappyKidsCommentSection",
  components: { VueSlickCarousel },
  props: {
    data: {
        type: Object,
        default: () => {},
    }
  },
  data() {
    return {
      locale: this.$i18n.locale,
      slidePerPage: 4,
      carouselSettings: {
        "arrows": true,
        "dots": true,
        "infinite": true,
        "speed": 500,
        "slidesToShow": 4,
        "slidesToScroll": 1,
        "touchThreshold": 5,
        "autoplay": true,
        "responsive": [
          {
              "breakpoint": 1024,
              "settings": {
                "slidesToShow": 2.2,
                "slidesToScroll": 2,
                "infinite": false,
                "autoplay": false,
                "arrows": false
              }
          },
          {
              "breakpoint": 760,
              "settings": {
                "slidesToShow": 1.2,
                "slidesToScroll": 1,
                "infinite": false,
                "autoplay": false,
                "arrows": false
              }
          }
        ]
      }
    }
  }
};
